import React from "react";

export function StatusDot({ status }: { status: "healthy" | "degraded" | "down" | "unknown" }) {
  const colors = {
    healthy: "var(--c-success)",
    degraded: "var(--c-warning)",
    down: "var(--c-danger)",
    unknown: "var(--c-text-faint)",
  };
  return (
    <span className="relative flex h-2 w-2">
      {status === "healthy" && (
        <span
          className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-30"
          style={{ backgroundColor: colors[status] }}
        />
      )}
      <span
        className="relative inline-flex rounded-full h-2 w-2"
        style={{ backgroundColor: colors[status] }}
      />
    </span>
  );
}
